export default __webpack_public_path__ + "static/media/r6.39580def.png";